import React from "react";
import { QRCode } from "./styled";
const QrCode = props => {
  return <QRCode {...props} />;
};
export default QrCode;
